import request from '@/http/request'
import {
  getUserExtInfo,
  addStudentExt,
  UpdateRegistrationExt,
  selectOneSignUpExt,
  uploadExt,
  selectListExt,
  planStudentImportExt,
  studentExportExt,
  excelTempCreateExt,
  examineExtList,
  exportExamineExt,
  selectByOneInfo
} from '@/http/api'

export const getUserExtInfoFN = () => {
    return request({
        url: getUserExtInfo,
    })
}
export const addStudentExtSet = (data) => {
  return request({
      url: addStudentExt,
      data
  })
}
export const UpdateRegistration = (data) => {
  return request({
      url: UpdateRegistrationExt,
      data
  })
}
export const selectOneSignUp = (data) => {
  return request({
      url: selectOneSignUpExt,
      data
  })
}
export const uploadExtSet = (data) => {
  return request({
      url: uploadExt,
      isUpload:true,
      data
  })
}
export const selectList = (data) => {
  return request({
      url: selectListExt,
      data
  })
}
export const planStudentImport = (data) => {
  return request({
    url : planStudentImportExt,
    method : 'POST',
    isUpload:true,
    data
  })
}
export const studentExport = (data) => {
  return request({
    url : studentExportExt,
    method : 'POST',
    data
  })
}
export const excelTempCreate = (data) => {
  return request({
    url : excelTempCreateExt,
    method : 'POST',
    data
  })
}
export const examineList = (data) => {
  return request({
    url : examineExtList,
    method : 'POST',
    data
  })
}
export const exportExamine = (data) => {
  return request({
    url : exportExamineExt,
    method : 'POST',
    data
  })
}
export const selectByOne = (data) => {
  return request({
    url : selectByOneInfo,
    method : 'GET',
    data
  })
}
